import React, { memo } from "react";

import DatasetLineChart from "components/dashboard/charts/dataset-line-chart/DatasetLineChart";
import { Dialog } from "primereact/dialog";
import useDatasetIdentifiersStore from "store/dataset-identifiers-store";

type ScadaChartDialogProps = {
  dialog: boolean;
  setDialog: (bool: boolean) => void;
  dateTime: string | undefined;
}

const ScadaChartDialog: React.FC<ScadaChartDialogProps> = ({
	dialog,
	setDialog,
	dateTime
}) => {
	const selectedIds = useDatasetIdentifiersStore(state => state.ids);
	return <Dialog
	header='SCADA tags chart'
	visible={dialog}
	style={{ width: 'min(100vw, 1000px)', height: '500px' }}
	modal={false}
	resizable
	draggable
	maximizable
	onHide={() => setDialog(false)}>
	<DatasetLineChart
		identifiers={[...selectedIds]}
		referenceTime={dateTime}
		showDateSelection
		dynamicHeight
		chartDialogOpen={dialog}
	/>
</Dialog>;
}

export default memo(ScadaChartDialog)